import React, { useEffect, useState } from 'react';
import { Pagination } from 'antd';
import { TransactionFlowRecordFilterInitialValue } from './config/filterOptions';
import { TransactionFlowRecordColumns } from "./components/TransactionFlowRecordColumns";
import { useTransactionFlowRecordQuery } from "./hooks/useTransactionFlowRecordQuery";
import TransactionFlowRecordFilter from "./components/TransactionFlowRecordFilter";
import AdjustmentModal from "./components/AdjustmentModal";

const TransactionFlowPage: React.FC = () => {

    const [tempFilters, setTempFilters] = useState(TransactionFlowRecordFilterInitialValue());
    const [filters, setFilters] = useState(TransactionFlowRecordFilterInitialValue());
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [adjustmentModalVisible, setAdjustmentModalVisible] = useState(false);

    // 使用自定义hook获取数据
    const {
        transactionFlowRecordData,
        loading,
        refetch,
        totalElements,
        buildQueryVariables
    } = useTransactionFlowRecordQuery(filters, currentPage, pageSize);

    const handleResetFilters = () => {
        setTempFilters(TransactionFlowRecordFilterInitialValue());
        setFilters(TransactionFlowRecordFilterInitialValue());
    };

    const handleFilter = () => {
        setFilters(tempFilters);
        setCurrentPage(1);
    };

    const handleAdjustmentClick = () => {
        setAdjustmentModalVisible(true);
    };

    const handleAdjustmentModalClose = () => {
        setAdjustmentModalVisible(false);
    };

    // 添加useEffect监听状态变化后执行查询
    useEffect(() => {
        refetch(buildQueryVariables());
    }, [filters, currentPage, pageSize]);

    // 处理分页变化
    const handlePageChange = (page: number, pageSize: number) => {
        setCurrentPage(page);
        setPageSize(pageSize);
    };

    return (
        <div className="bg-white rounded-lg shadow-sm p-6">
            {/* 筛选条件 */}
            <TransactionFlowRecordFilter
                filters={tempFilters}
                setFilters={setTempFilters}
                handleFilter={handleFilter}
                handleResetFilters={handleResetFilters}
                onAdjustmentClick={handleAdjustmentClick}
            />

            {/* 调账弹窗 */}
            <AdjustmentModal
                visible={adjustmentModalVisible}
                onCancel={handleAdjustmentModalClose}
            />

            {/* 交易流水列表 */}
            <TransactionFlowRecordColumns
                rowData={transactionFlowRecordData}
                loading={loading}
                timeZoneId={filters.timeZoneId || 'UTC'}
            />

            {/* 分页 */}
            <div className="flex justify-between items-center">
                <div className="text-gray-500">{totalElements} results</div>
                <Pagination
                    current={currentPage}
                    total={totalElements}
                    pageSize={pageSize}
                    size="small"
                    showSizeChanger
                    onChange={handlePageChange}
                />
            </div>
        </div>
    );
};

export default TransactionFlowPage;


